var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('h2',{staticClass:"mb-0 f-20 fw-semibold poppins"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"page-title-right"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }